import { QueryClient } from '@tanstack/react-query';

export const platformQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 10, // 10 seconds stale time
    },
  },
});
